import { useOverlayRef } from '@aigc/overlay-hook';
import { Modal as AntdModal, type ModalProps as AntdModalProps } from 'antd';
import { useEffect, useState } from 'react';

export type AiModalProps = Omit<AntdModalProps, 'open'>;

/**
 * 即用即扔的 Modal，一般需要与 useOverlay 一起使用
 *
 * 处理了弹出/关闭逻辑以更适合与 useOverlay 一起使用的场景
 */
export const AiModal = (props: AiModalProps) => {
  const [open, setOpen] = useState(true);
  const [resolve, setResolve] = useState(() => () => {
    /* empty */
  });

  const overlayRef = useOverlayRef();

  useEffect(() => {
    const dispose = overlayRef?.onBeforeClose(() => {
      // 等 Modal 的关闭动画完成后再销毁组件
      return new Promise<void>((resolve) => {
        setOpen(false);
        setResolve(() => resolve);
      });
    });

    return () => {
      dispose?.();
    };
  }, [overlayRef]);

  return (
    <AntdModal
      {...props}
      open={open}
      afterClose={() => {
        props.afterClose?.();
        resolve?.();
      }}
      onOk={props.onOk}
      onCancel={props.onCancel}
    >
      {props.children}
    </AntdModal>
  );
};
